module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article"
  }, [_c('ul', {
    staticClass: "has-data"
  }, _vm._l((_vm.articleList), function(item, index) {
    return _c('li', {
      key: index,
      class: ("data-item data-item" + (item.id))
    }, [_c('articleContainer', {
      attrs: {
        "userId": _vm.userId,
        "articleInfo": item
      },
      on: {
        "tagSelector": _vm.tagSelector,
        "onVoteToggle": _vm.onVoteToggle,
        "favoriteToggle": _vm.favoriteToggle
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.questionList.length),
      expression: "questionList.length"
    }],
    staticClass: "load-more"
  }, [(_vm.isLoading) ? _c('img', {
    attrs: {
      "alt": "loadding",
      "src": require("../../images/common/loading_2_24x24.gif")
    }
  }) : (Math.ceil(_vm.articleList.length / 10) === _vm.listCount) ? _c('p', {
    staticClass: "no-more"
  }, [_vm._v("没有更多文章了")]) : _c('p', {
    on: {
      "click": function($event) {
        return _vm.doLoadMore()
      }
    }
  }, [_vm._v("加载更多")])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7b22dcf8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/community/article.vue
// module id = /5TV
// module chunks = 15